/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app-header.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./app-header.component";
import * as i3 from "../services/auth.service";
var styles_AppHeaderComponent = [i0.styles];
var RenderType_AppHeaderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppHeaderComponent, data: {} });
export { RenderType_AppHeaderComponent as RenderType_AppHeaderComponent };
export function View_AppHeaderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_AppHeaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-header", [], null, null, null, View_AppHeaderComponent_0, RenderType_AppHeaderComponent)), i1.ɵdid(1, 49152, null, 0, i2.AppHeaderComponent, [i3.AuthService], null, null)], null, null); }
var AppHeaderComponentNgFactory = i1.ɵccf("app-header", i2.AppHeaderComponent, View_AppHeaderComponent_Host_0, { title: "title", subtitle: "subtitle" }, {}, []);
export { AppHeaderComponentNgFactory as AppHeaderComponentNgFactory };
